import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import { apiName } from 'assets';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

export const postPartnerSurveySubmitted = async ({
  tinyaccount_id,
  kit_id,
  form_id,
}: {
  tinyaccount_id: string;
  kit_id?: string;
  form_id: string;
}) => {
  const response = await API.post(
    apiName,
    `/public/kits/typeform_submit`,
    {
      body: {
        form_id,
        kit_id: kit_id ?? null,
        tinyaccount_id: tinyaccount_id ?? null,
      },
    },
    false,
    undefined,
    {
      tags: {
        section: SECTIONS.KITS,
        domain: DOMAINS.SURVEYS,
        importance: IMPORTANCE.CRITICAL,
      },
      context: {
        tinyAccountId: tinyaccount_id,
        kitId: kit_id,
        formId: form_id,
      },
    },
  );
  return response;
};
const useSubmitFinishedPartnerSurvey = () => {
  const trackEvent = useAnalytics().trackEvent;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (properties: {
      form_id: string;
      tinyaccount_id: string;
      kit_id: string;
    }) => {
      //we log the event before to ensure it is logged even if the update fails
      trackEvent('Survey Completed', properties);
      return postPartnerSurveySubmitted(properties);
    },
    onSuccess(data, variables, context) {
      const queryKey = ['unregisteredKit', variables.kit_id];
      queryClient.setQueryData(queryKey, (oldData: any) => ({
        ...oldData,
        date_survey_completed: format(new Date(), 'yyyy-MM-dd'),
      }));
      // No success toast: the partner flow always runs the ENG-4942 redesign
      // (it is anonymous, so a per-account flag can never be true there), and
      // the redesign announces completion with its own screen.
    },
    onError: (err, variables, context) => {
      toast.error(
        'There was an error submitting the survey. Please try again.',
      );
    },
  });
};
export default useSubmitFinishedPartnerSurvey;
